export default "<div class=\"semi-circle-chart\"></div>"